import {PriceModel} from '../Price.model';

export class PaymentSummaryModel {
  public payNow: PriceModel;
  public payLater: PriceModel;
  public payAfterFreeTrial: PriceModel;

  constructor(params: PaymentSummaryModel) {
    this.payNow = params.payNow;
    this.payLater = params.payLater;
    this.payAfterFreeTrial = params.payAfterFreeTrial;
  }

  public static fromCartV1({
    payNow,
    payLater,
    payAfterFreeTrial,
  }: {
    payNow: PriceModel;
    payLater: PriceModel;
    payAfterFreeTrial: PriceModel;
  }): PaymentSummaryModel {
    return new PaymentSummaryModel({
      payNow,
      payLater,
      payAfterFreeTrial,
    });
  }
}
